import React, { Component } from 'react';
import { headers,BaseURLDev } from '../../../../../_utils/config';
import { terbilang } from '../../../../../_utils/terbilang';
import { toIDR } from '../../../../../_utils/tocurrency';
import { Menu, Dropdown, Loader, Table, Icon, Segment, Button } from 'semantic-ui-react';
import printJS from 'print-js';
import moment from 'moment'
import jsPDF from 'jspdf'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import swal from 'sweetalert'

export default class AnggaranRealisasi42 extends Component {
   constructor(props){
      super(props);
      this.state = { 
         data : null,
         rek_1 : null,
         rek_2 : null,
         rek_3 : null,
         rek_4 : null,
         rek_5 : null,
         requests : false,
         is_print : false,
         kalkukasi: null
      }
     
   }
   
   getData(){
      this.setState({requests:true})
      fetch(`${BaseURLDev}/simantra/anggaranrealisasirek?rek_2=2`, { headers })
      .then(response => {
         if(!response.ok){
            swal("Load data gagal", {icon:"error"})
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         this.setState({
            data : resJSON.data,
            rek_1 : resJSON.data.rek_1,
            rek_2 : resJSON.data.rek_2,
            rek_3 : resJSON.data.rek_3,
            rek_4 : resJSON.data.rek_4,
            rek_5 : resJSON.data.rek_5,
            requests : false,
         })
      })
   }

   componentWillMount(){
      this.getData()
   }

   guid() {
      return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
      this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }
    
    s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

   renderAnu(kd_rek,nm_rek,rencana,realisasi) {
      return (
            <Table.Row key={this.guid()}>               
               <Table.Cell>{kd_rek}</Table.Cell>
               <Table.Cell>{nm_rek}</Table.Cell>
               <Table.Cell><a title={terbilang(rencana)}>{toIDR(rencana)}</a></Table.Cell>
               <Table.Cell><a title={terbilang(realisasi)}>{toIDR(realisasi)}</a></Table.Cell>
            </Table.Row>
      )
   }

   exportData(opt){
      if(opt==='excel'){
         this.exportMode().toCSV('print_data',`${moment().format("DD_MM_YYYY_HH_mm_ss")}`)
      }
      else if(opt==='pdf'){
         this.setState({is_print:true})
         this.exportToPDF(`${moment().format("DD_MM_YYYY_HH_mm_ss")}`)
      }
      else{
         printJS({
            printable: 'data_print',
            type: 'html',
            modalMessage:"Sedang memuat data...",
            showModal:true,
            maxWidth:'1300',
            font_size:'8pt',
            documentTitle:`${moment().format('DD-MM-YYYY--HH:mm:ss')}`,
            targetStyle: [
               'margin',
               'color',
               'border-collapse',
               'border-spacing',
               'border-style',
               'border-style',
               'margin-bottom',
               'background',
               'padding'
            ]
         })
      }
   }

   exportToPDF(file_name) {
      var pdf = new jsPDF('l', 'pt', 'legal');
      var source = document.getElementById("data_print");
      var margins = {
         top: 40,
         bottom: 60,
         left: 30,
         width: 1000
      };
      
      pdf.fromHTML(
         source, // HTML string or DOM elem ref.
         margins.left, // x coord
         margins.top, { // y coord
            'width': margins.width, // max width of content on PDF
         },

         function (dispose) {
            // dispose: object with X, Y of the last line add to the PDF 
            //          this allow the insertion of new lines after html
            pdf.save(`${file_name}.pdf`);
         }, margins
      );
      this.setState({is_print:false})         
      
   }

   exportMode(){
      return {
         _fallbacktoCSV: true,  
         toXLS: function(tableId, filename) {   
            this._filename = (typeof filename === 'undefined') ? tableId : filename;

            //var ieVersion = this._getMsieVersion();
            //Fallback to CSV for IE & Edge
            if ((this._getMsieVersion() || this._isFirefox()) && this._fallbacktoCSV) {
               return this.toCSV(tableId);
            } else if (this._getMsieVersion() || this._isFirefox()) {
               alert("Not supported browser");
            }

            //Other Browser can download xls
            var htmltable = document.getElementById(tableId);
            var html = htmltable.outerHTML;

            this._downloadAnchor("data:application/vnd.ms-excel" + encodeURIComponent(html), 'xls'); 
         },
         toCSV: function(tableId, filename) {
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            // Generate our CSV string from out HTML Table
            var csv = this._tableToCSV(document.getElementById(tableId));
            // Create a CSV Blob
            var blob = new Blob([csv], { type: "text/csv" });

            // Determine which approach to take for the download
            if (navigator.msSaveOrOpenBlob) {
               // Works for Internet Explorer and Microsoft Edge
               navigator.msSaveOrOpenBlob(blob, this._filename + ".csv");
            } else {      
               this._downloadAnchor(URL.createObjectURL(blob), 'csv');      
            }
         },
         toPDF: function(tableId, filename) {
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            // Generate our CSV string from out HTML Table
            var pdf = document.getElementById(tableId);
            // Create a CSV Blob
            var blob = new Blob([pdf], { type: "text/pdf" });

            // Determine which approach to take for the download
            if (navigator.msSaveOrOpenBlob) {
               // Works for Internet Explorer and Microsoft Edge
               navigator.msSaveOrOpenBlob(blob, this._filename + ".pdf");
            } else {      
               this._downloadAnchor(URL.createObjectURL(blob), 'pdf');      
            }
         },
         _getMsieVersion: function() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf("MSIE ");
            if (msie > 0) {
               // IE 10 or older => return version number
               return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
            }

            var trident = ua.indexOf("Trident/");
            if (trident > 0) {
               // IE 11 => return version number
               var rv = ua.indexOf("rv:");
               return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
            }

            var edge = ua.indexOf("Edge/");
            if (edge > 0) {
               // Edge (IE 12+) => return version number
               return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
            }

            // other browser
            return false;
         },
         _isFirefox: function(){
            if (navigator.userAgent.indexOf("Firefox") > 0) {
               return 1;
            }

            return 0;
         },
         _downloadAnchor: function(content, ext) {
            var anchor = document.createElement("a");
            anchor.style = "display:none !important";
            anchor.id = "downloadanchor";

            document.body.appendChild(anchor);

            // If the [download] attribute is supported, try to use it
            if ("download" in anchor) {
               anchor.download = this._filename + "." + ext;
            }
            anchor.href = content;
            anchor.click();
            anchor.remove();
         },
         _tableToCSV: function(table) {
            // We'll be co-opting `slice` to create arrays
            var slice = Array.prototype.slice;

            return slice
            .call(table.rows)
            .map(function(row) {
               return slice
               .call(row.cells)
               .map(function(cell) {
                  return '"t"'.replace("t", cell.textContent);
               })
               .join(",");
            })
            .join("\r\n");
         }
      }
   }

   render() {
      const { rek_1, rek_2, rek_3, rek_4, rek_5 } = this.state
      // const { rek_1, rek_2, rek_3, rek_4 } = this.state
      const anuComp = []
      const styletb = {
         borderCollapse:'collapse',
         borderSpacing:0,
         borderStyle:'solid',
         width:'100%',
      }

      if(this.state.data !== null){
         for(let aa=0;aa<rek_1.length;aa++){
            anuComp.push(this.renderAnu(rek_1[aa].kd_rek,rek_1[aa].nm_rek,rek_1[aa].rencana,rek_1[aa].realisasi)) ;            
            for(let a=0;a<rek_2.length;a++){
               anuComp.push(this.renderAnu(rek_2[a].kd_rek,rek_2[a].nm_rek,rek_2[a].rencana,rek_2[a].realisasi)) ;
               // this.kalkulasiData(rek_2[a].kd_rek,rek_2[a].nm_rek,rek_2[a].rencana,rek_2[a].realisasi);
               for(let b=0;b<rek_3.length;b++){
                  if((rek_3[b].kd_rek).indexOf(rek_2[a].kd_rek)!==-1) {
                     anuComp.push(this.renderAnu(rek_3[b].kd_rek,rek_3[b].nm_rek,rek_3[b].rencana,rek_3[b].realisasi)) ;
                     // this.kalkulasiData(rek_3[b].kd_rek,rek_3[b].nm_rek,rek_3[b].rencana,rek_3[b].realisasi);

                     for(let c=0;c<rek_4.length;c++){
                        if((rek_4[c].kd_rek).indexOf(rek_3[b].kd_rek)!==-1) {
                           anuComp.push(this.renderAnu(rek_4[c].kd_rek,rek_4[c].nm_rek,rek_4[c].rencana,rek_4[c].realisasi)) ;
                           // this.kalkulasiData(rek_4[c].kd_rek,rek_4[c].nm_rek,rek_4[c].rencana,rek_4[c].realisasi);

                           for(let d=0;d<rek_5.length;d++){
                              if((rek_5[d].kd_rek).indexOf(rek_4[c].kd_rek)!==-1) {
                                 anuComp.push(this.renderAnu(rek_5[d].kd_rek,rek_5[d].nm_rek,rek_5[d].rencana,rek_5[d].realisasi)) ;
                                 // this.kalkulasiData(rek_5[d].kd_rek,rek_5[d].nm_rek,rek_5[d].rencana,rek_5[d].realisasi);
                              }
                           }
                        }
                     }
                  }
               }
            }
         }
      }

      return (
         <span>
            <Menu>
               <Menu.Item>
                  <Button color='blue' size="small" onClick={()=>this.exportData('print')}> 
                     <p><Icon name='print' className='left floated' />Preview</p>
                  </Button> 
               </Menu.Item>
            </Menu>
            <Segment> {this.state.requests ?
               <Loader active inline='centered' size='medium'>Loading...</Loader>:
               this.state.requests ? 
                  <Table size='small'>
                     <Table.Body>
                        <Table.Row>
                           <Table.Cell>
                              <SkeletonTheme color="#202020" highlightColor="#444">
                                 <Skeleton count={7} />
                              </SkeletonTheme>
                           </Table.Cell>
                           <Table.Cell>
                              <SkeletonTheme color="#202020" highlightColor="#444">
                                 <Skeleton count={7} />
                              </SkeletonTheme>
                           </Table.Cell>
                           <Table.Cell>
                              <SkeletonTheme color="#202020" highlightColor="#444">
                                 <Skeleton count={7} />
                              </SkeletonTheme>
                           </Table.Cell>
                           <Table.Cell>
                              <SkeletonTheme color="#202020" highlightColor="#444">
                                 <Skeleton count={7} />
                              </SkeletonTheme>
                           </Table.Cell>
                        </Table.Row>
                     </Table.Body>
                  </Table>
                  :
                  <div id="data_print" style={{width:'100%'}}>
                     
                     <Table border='1' style={styletb} size='small' id="print_data" width="100%">
                        <Table.Header>
                           <Table.Row>
                              <Table.HeaderCell>Kode Rekening</Table.HeaderCell>
                              <Table.HeaderCell>Uraian Rekening</Table.HeaderCell>
                              <Table.HeaderCell>Target</Table.HeaderCell>
                              <Table.HeaderCell>Realisasi</Table.HeaderCell>
                           </Table.Row>
                        </Table.Header>
                        <Table.Body>
                           {                     
                              this.state.data !== null && anuComp
                           }
                        </Table.Body>                  
                     </Table>
                  </div>
               }
            </Segment>
         </span>
      );
   }
}





// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_report/AnggaranRealisasi42.js